module.exports = __webpack_public_path__ + "static/media/gryphon-house-building-left.1f5a764f.jpg";